export default __webpack_public_path__ + "static/media/invoice_background.9e96f5b3.svg";